import { render } from "./Index.vue?vue&type=template&id=4133305e&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=4133305e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4133305e"

export default script